/* POPUP */
export const SET_CARD_LIST = "SET_CARD_LIST";